const fourFourSchema = {
  title: "4_4 Use of Assets (through leased equipment) by an Organization",
  addAPI: "cat4_4AddEmissionActivityAPI",
  cat: "cat4_4",
  EATitle: "Emission Activity",
  fields: [
    //////// Activity Name
    {
      key: "itemName",
      level: 1,
      type: "input",
      label: "Activity Name",
      resetOnChange: false,
      required: true,
    },
    //////// Asset Name
    {
      key: "assetName",
      level: 1,
      type: "input",
      label: "Asset Name",
      resetOnChange: false,
      required: true,
    },
  ],
};
export default fourFourSchema;
